export const debounce = (func, time) => {
    return function (args) {
        let previousCall = this.lastCall
        this.lastCall = Date.now()
        if (previousCall && ((this.lastCall - previousCall) <= time)) {
            clearTimeout(this.lastCallTimer)
        }
        this.lastCallTimer = setTimeout(() => func(args), time)
    }
}



// WEBPACK FOOTER //
// ./src/util/debounce.js